/**
 * PHSIMS Version Configuration
 * 
 * Author: Iswe Solutions Team
 * Purpose: Single source of truth for application version info
 * 
 * Version is dynamically injected at build time via Vite from package.json.
 * Build hash and date are also injected for debugging/traceability.
 * 
 * To update the version:
 * 1. Update "version" in package.json (follow SemVer: MAJOR.MINOR.PATCH)
 * 2. Rebuild the frontend
 * 
 * SemVer Guidelines:
 * - MAJOR: Breaking changes, incompatible API changes
 * - MINOR: New features, backward compatible
 * - PATCH: Bug fixes, backward compatible
 */

// Injected at build time by Vite (see vite.config.ts)
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || '1.0.0';
export const BUILD_HASH = import.meta.env.VITE_BUILD_HASH || '';
export const BUILD_DATE = import.meta.env.VITE_BUILD_DATE || new Date().toISOString().split('T')[0];

// Formatted version strings
export const VERSION_SHORT = `v${APP_VERSION}`;
export const VERSION_FULL = BUILD_HASH 
  ? `v${APP_VERSION} (${BUILD_HASH.substring(0, 7)})`
  : `v${APP_VERSION}`;
export const VERSION_WITH_DATE = `Version ${APP_VERSION} • Built ${BUILD_DATE}`;

// For display in UI
export const getVersionInfo = () => ({
  version: APP_VERSION,
  hash: BUILD_HASH,
  date: BUILD_DATE,
  short: VERSION_SHORT,
  full: VERSION_FULL,
  withDate: VERSION_WITH_DATE,
});
